<template>
  <div class="hash-display">
    <div class="hash-art">
      <div class="hash-grid">
        <div v-for="(value, index) in hashValues" :key="index" :style="{ opacity: value }"></div>
      </div>
    </div>
    <div class="hash">
      <span v-for="(char, index) in hash.split('')" :key="index">{{ char }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HashDisplay',
  props: {
    hash: String
  },
  computed: {
    hashValues () {
      if (/^[0-9a-f]{64}$/i.test(this.hash)) {
        return this.hash.split('').map(char => parseInt(char, 16) / 15)
      } else {
        return Array(64).fill(0)
      }
    }
  }
}
</script>

<style>
.hash-display {
  display: inline-flex;
  /* background: #fff; */
  border-radius: 4px;
  height: 56px;
  /* padding: 8px; */
}
.hash-art {
  display: none;
}

.hash-grid {
  display: grid;
  grid-template-columns: repeat(8, 7px);
  grid-template-rows: repeat(8, 7px);
}

.hash-grid div {
  background: #001DDD;
  transition: opacity 0.3s;
}
.hash-grid div:nth-child(1) {
  border-top-left-radius: 4px;
}
.hash-grid div:nth-child(8) {
  border-top-right-radius: 4px;
}
.hash-grid div:nth-child(57) {
  border-bottom-left-radius: 4px;
}
.hash-grid div:nth-child(64) {
  border-bottom-right-radius: 4px;
}

.hash {
  font-family: "Roboto Mono", monospace;
  font-size: 12px;
  line-height: 14px;
  /* display: inline-flex; */
  /* flex-wrap: wrap; */
  width: 128px;
  align-items: center;
  align-content: center;
  color: #696b85;
}

.hash span {
  width: 8px;
  text-align: center;
  display: inline-block;
}

@media screen and (min-width: 420px) {
  .hash-art {
    display: block;
    flex-grow: 0;
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    margin-right: 8px;
  }
}
</style>
